import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject, Subscription} from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {FrontUserService} from '../../../core/services/frontUsers.service';
import {DataSource , SelectionModel} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {FuseUtils} from '../../../core/fuseUtils';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { TargetGroupService } from '../../../core/services/targetGroup.service';
import { FuseConfigService } from '../../../core/services/config.service';
import { UserService } from '../../../core/services/users.service';
import { ImportUserComponent } from './importUser/importUser.component';
import { BookEventComponent } from "./bookEvent/book-event.component";
import {Router} from "@angular/router";
import {FrontUserNoActiveService} from "../../../core/services/frontUsersNoActive.service";
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../../core/services/event.service';
@Component({
    selector: 'frontusersnoactive-page',
    templateUrl: './frontusersnoactive.component.html',
    styleUrls: ['./frontusersnoactive.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FrontUsersNoActiveComponent implements OnInit, OnDestroy {
  public filterData: any = {};

  users: FilesDataSource | null;
  displayedColumns = ['select', 'logo' , 'name' , 'email' , 'sms', 'address' , 'targetGroup', 'organization'  , 'canton' , 'connection' ] ;
  targetGroupChoose = 0;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  isOrganizer = false;
  isSubCountry = false;
  isCountry = false;
  selection = new SelectionModel<any>(true, []);

  userFilters;
  defUserFilters;

  checkedUsers = [];
  eCall = false;
  whatsapp = false;

  hideButton = true;
  _pageIndex = 0;
  firstPaginatorEmit = true;
  selectedVal = 'hide';
  platformId;
  public subscription = new Subscription();


  constructor (private http: HttpClient , private usersService: FrontUserService , private spinner: NgxSpinnerService ,
               private organizationService: OrganizationsService, public snackBar: MatSnackBar,
               private targetService: TargetGroupService, private fuseConfig: FuseConfigService, private router: Router ,
               public _userService: UserService, public dialog: MatDialog, private usersNoActiveService: FrontUserNoActiveService,
                private toastr: ToastrService, public eventService: EventService) {
    this.fuseConfig.eCall.subscribe(res => {
      if (res && res !== 'null') {
        this.eCall = true;
      }
    });
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup', 'connection' ] ;
        this.isOrganizer = true;
      }
      if (res && res === 'subCountryAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup', 'organization'  , 'connection' ] ;
        this.isOrganizer = false;
      }
      if (res && res === 'countryAdmin') {
        this.displayedColumns = ['select', 'logo' , 'name' , 'email', 'sms', 'address'  , 'targetGroup', 'organization', 'canton' , 'connection' ] ;
        this.isOrganizer = false;
      }
    });

    this.subscription.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        if (res.id !== this.platformId && this.platformId) {
          this.platformId = res.id;
          this.fetchData();
        }
        this.platformId = res.id;
      }
    }));
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit () {
    this.spinner.show();
    this.users = new FilesDataSource(this.usersNoActiveService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (!this.users) {
          return;
        }
        this.users.filter = this.filter.nativeElement.value;
        localStorage.setItem('frontUserNASearch', this.filter.nativeElement.value);
        this.paginator.firstPage();
        this.cleanScrollFUNA();
      });
    this.getCountries();
    this.getRole();
    this.getTargetGroups();
    this.alertMsg();
    this.getUserFilters();
    setTimeout(() => {
      this.spinner.hide();
      let table = document.getElementById('frontUserPage');
      if (table && localStorage.getItem('frontUserNAScroll')) {
        table.scrollTop = +localStorage.getItem('frontUserNAScroll');
      }
    }, 500);
    this._pageIndex = +localStorage.getItem('frontUserNAPageIndex');
    let _userSearch = localStorage.getItem('frontUserNASearch');
    if (_userSearch) {
      this.users.filter = _userSearch;
      this.filter.nativeElement.value = _userSearch;
    }
  }


  download() {
    let url = this.usersService.exportUser(this.platformId);
    const downloadURL = url;
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = downloadURL;
    // link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  alertMsg() {
    if (this.usersService.addSuccess) {
      this.usersService.addSuccess = false;
      this.snackBar.open('Successfully  added', '', {duration: 2500});
    }
  }

  getRole () {
    this.usersService.getRoles().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.roles = res;
      } else {
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
      } else if (res.length === 1) {
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }
  getTargetGroups () {
    this.targetService.getTargetGroups(false).then((data: any) => {
      this.filterData.targetGroups = data.targetGroups;
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }
  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantons = res;
      } else if (res.length === 1) {
        this.usersService.setCities({selected: true, canton: res[0].id});
        this.getOrganizations();
        delete this.filterData.cantons;
      } else {
        delete this.filterData.cantons;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.usersService.getOrganizationByCantons().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizations = res;
      } else if (res.length === 1) {
        this.usersService.setOrganizations({selected: true, organization: res[0].id});
        this.getTags();
        this.fetchData();
        delete this.filterData.organizations;
      } else {
        delete this.filterData.organizations;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getTags() {
    this.usersService.getTagByOrganization().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.tags = res;
      } else if (res.length === 1) {
        this.usersService.setTags(res[ 0 ].id);
        this.fetchData();
        delete this.filterData.tags;
      } else {
        delete this.filterData.tags;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    console.log(e);
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      delete this.filterData.tags;
      delete this.filterData.targetGroups;
      delete this.filterData.roles;
      this.usersService.setToAll();
      this.fetchData();
      this.getCountries();
      this.getRole();
      this.getTargetGroups();
      this.fuseConfig.setActiveFilter(false);
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantons;
      delete this.filterData.organizations;
      delete this.filterData.tags;
      this.getCantons(e.choose.country);
      this.usersService.setCountryId(e.choose.country);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('canton')) {
      delete this.filterData.organizations;
      delete this.filterData.tags;
      this.usersService.setCities(e.choose);
      this.fetchData();
      this.getOrganizations();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('organization')) {
      delete this.filterData.tags;
      this.usersService.setOrganizations(e.choose);
      this.fetchData();
      this.getTags();
      this.fuseConfig.setActiveFilter(true);
    }  else if (e.choose.hasOwnProperty('tag')) {
      this.usersService.setTags(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }  else if (e.choose.hasOwnProperty('targetGroups')) {
      this.usersService.setTargetGroups(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('role')) {
        this.usersService.setRoles(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    this.setDataFromFilter(e);
  }

  getUserFilters() {
    this._userService.getFilter('user').subscribe((res: any) => {
      if (res) {
        this.defUserFilters = res;
        this.userFilters = { user: JSON.parse(res.config)};
        const config = JSON.parse(res.config);
        if (Object.keys(config).length) {
          this.fuseConfig.setActiveFilter(true);
        } else {
          this.fuseConfig.setActiveFilter(false);
        }
        if (config.hasOwnProperty('targetGroups')) {
          config.targetGroups.forEach(el => {
            this.usersService.setTargetGroups({targetGroups: el, selected: true});
          });
        }

        if (config.hasOwnProperty('roles')) {
          config.roles.forEach(el => {
            this.usersService.setRoles({role: el, selected: true});
          });
        }
        const countryPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('country')) {
            this.usersService.setCountryId(config.country);
            this.organizationService.getCity(+config.country).subscribe((resCanton: any) => {
              if (resCanton.length > 1) {
                this.filterData.cantons = resCanton;
              } else if (resCanton.length === 1) {
                this.usersService.setCities({selected: true, canton: resCanton[0].id});
                this.getOrganizations();
                delete this.filterData.cantons;
              } else {
                delete this.filterData.cantons;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
        const cantonsPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('cantons')) {
            config.cantons.forEach(el => {
              this.usersService.setCities({canton: el, selected: true});
            });
            this.usersService.getOrganizationByCantons().subscribe((resOrg: any) => {
              if (resOrg.length > 1) {
                this.filterData.organizations = resOrg;
              } else if (resOrg.length === 1) {
                this.usersService.setOrganizations(resOrg[ 0 ].id);
                this.fetchData();
                delete this.filterData.organizations;
              } else {
                delete this.filterData.organizations;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
        const organizationPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('organizations')) {
            config.organizations.forEach(el => {
              this.usersService.setOrganizations({organization: el, selected: true});
            });
            this.usersService.getTagByOrganization().subscribe((resTag: any) => {
              if (resTag) {
                this.filterData.tags = resTag;
              }
            } );
            resolve(true);
          } else {
            resolve(true);
          }
        });

        Promise.all([countryPromise, cantonsPromise, organizationPromise]).then(values => {
          console.log(values);
          this.fetchData();
        });

      } else {
        this.fuseConfig.setActiveFilter(false);
        this.userFilters = { user: {}};
        this.defUserFilters = '';
      }
    });
  }

  setUserFilters(key, value) {
    this.userFilters.user[key] = value;
    this._userService.setFilters('user', this.userFilters.user, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setEmptyUserFilters() {
    this._userService.setFilters('user', {}, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setDataFromFilter(e) {
    if (e.choose === 'all') {
      this.userFilters.user = {};
      this.setEmptyUserFilters();
    } else if (e.choose.hasOwnProperty('country')) {
      this.setUserFilters('country', e.choose.country);
    } else if (e.choose.hasOwnProperty('canton')) {
      const _cities = this.usersService.getCities();
      this.setUserFilters('cantons', _cities);
    } else if (e.choose.hasOwnProperty('organization')) {
      const _organizations = this.usersService.getOrganizations();
      this.setUserFilters('organizations', _organizations);
    }else if (e.choose.hasOwnProperty('tag')) {
      const _tags = this.usersService.getTags();
      this.setUserFilters('tags', _tags);
    }
    else if (e.choose.hasOwnProperty('targetGroups')) {
      const _targetGroups = this.usersService.getTargetGroups();
      this.setUserFilters('targetGroups', _targetGroups);
    }
    else if (e.choose.hasOwnProperty('role')) {
      const _role = this.usersService.getRolesIds();
      this.setUserFilters('roles', _role);
    }
  }


  fetchData () {
    this.selection.clear();
    this.checkedUsers = [];
    this.spinner.show();

    this.usersNoActiveService.getUsers().then(() => {
      setTimeout(() => {
        if (this.firstPaginatorEmit) {
          this._pageIndex = +localStorage.getItem('frontUserNAPageIndex') ? +localStorage.getItem('frontUserNAPageIndex') : 0;
          this.firstPaginatorEmit = false;
        } else {
          this.paginator.firstPage();
          this.cleanScrollFUNA();
        }
        this.spinner.hide();
      } , 500);
    });
  }

  changePageEmitter(e) {
    localStorage.setItem('frontUserNAPageIndex' , e.pageIndex);
    this.cleanScrollFUNA();
  }
  onScroll(e) {
    localStorage.setItem('frontUserNAScroll' , e.target.scrollTop);
  }
  cleanScrollFUNA() {
    let table = document.getElementById('frontUserPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('frontUserNAScroll' , '0');
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.users.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.users.filteredData.forEach(row => this.selection.select(row));
    this.checkedUsers = this.selection.selected;
    console.log(this.checkedUsers);
  }

  checkUser(user, event) {
    if (event.checked) {
      this.checkedUsers.push(user);
    } else {
      let index = this.checkedUsers.findIndex(x => +x.id === +user.id);
      if (index !== -1) {
        this.checkedUsers.splice(index, 1);
      }
    }
    console.log(this.checkedUsers);
  }

  openImportModal() {
    let dialogRef = this.dialog.open(ImportUserComponent, {
      panelClass: 'import-user-dialog',
      width: '70vw',
    });
    dialogRef.afterClosed().subscribe(res => {
      this.fetchData();
    });
  }

  openBookModal() {
    let dialogRef = this.dialog.open(BookEventComponent, {
      panelClass: 'book-event-dialog',
      width: '70vw',
      data: this.checkedUsers
    });
  }

  communicationAction(event) {
    if (event.value === 'emailList') {
      this.selectedVal = event.value;
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++) {
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
      }
      if (!emails.length) {
        this.toastr.error('Ausgewählte User haben keine E-Mail' , 'Error!');
        setTimeout(() => {
          this.selectedVal = 'hide';
        }, 500);
        return;
      }
      const to = emails[0];
      emails.shift();
      const cc = '';
      const bcc = emails.join(',');
      const subject = 'Betreff der E-Mail';
      const body = 'Inhalt der E-Mail...';

      this.generateEmlFile(to, cc, bcc, subject, body);
      setTimeout(() => {
        this.selectedVal = 'hide';
      }, 500);
      return;
    }
    let ids = [];
    for (let i = 0; i < this.checkedUsers.length; i++ ) {
      ids.push(this.checkedUsers[i].id);
    }
    this.router.navigate(['/pages/communications'], {queryParams: {
      type: event.value,
      ids: ids.toString(),
    }});
  }

  generateEmlFile(to, cc, bcc, subject, body) {
    const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\n\r\n${body}`;

    const blob = new Blob([emlContent], { type: 'message/rfc822' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'email.eml';
    a.click();

    URL.revokeObjectURL(url);
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private usersService: FrontUserNoActiveService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.usersService.users;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.usersService.onUsersChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.usersService.users.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }



  sortData (data): any[] {
    if (this._sort.active) {
      localStorage.setItem('frontUserNASort' , this._sort.active);
      localStorage.setItem('frontUserNASortDirection' , this._sort.direction);
    }

    let sortFromLS: any = localStorage.getItem('frontUserNASort');
    let sortDirFromLS: any = localStorage.getItem('frontUserNASortDirection');
    if (sortFromLS && sortDirFromLS) {
      this._sort.active = sortFromLS;
      this._sort.direction = sortDirFromLS;
    }

    if (!this._sort.active || this._sort.direction === '') {
      if (!sortFromLS) {
        return data;
      }
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active ? this._sort.active : sortFromLS) {
        case 'email':
          [ propertyA , propertyB ] = [ a.email , b.email ];
          break;
        case 'name':
          [ propertyA , propertyB ] = [ (a.lastName + a.firstName) ,  (b.lastName + b.firstName) ];
          break;
        case 'lang':
          [ propertyA , propertyB ] = [ a.lang , b.lang ];
          break;
        case 'country':
          [ propertyA , propertyB ] = [ a.country ? a.country.name : null , b.country ? b.country.name : null ];
          break;
        case 'canton':
          [ propertyA , propertyB ] = [ a.city ? a.city.name : null , b.city ? b.city.name : null ];
          break;
        case 'role':
          [ propertyA , propertyB ] = [ a.frontRole.name , b.frontRole.name ];
          break;
        case 'organization':
          [ propertyA , propertyB ] = [ a.organization ? a.organization.name : null , b.organization ? b.organization.name : null ];
          break;

      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      let direction = this._sort.direction ? this._sort.direction : sortDirFromLS;

      return (valueA < valueB ? -1 : 1) * (direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
